/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ApparelInputs */

const en_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparel`)
};

const es_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ropa`)
};

const fr_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vêtements`)
};

const de_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekleidung`)
};

const ja_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アパレル`)
};

const zh_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服饰`)
};

const ar_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملابس`)
};

const id_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakaian`)
};

const it_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbigliamento`)
};

const ru_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одежда`)
};

const pt_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vestuário`)
};

const ko_apparel = /** @type {(inputs: ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`의류`)
};

/**
* | output |
* | --- |
* | "Apparel" |
*
* @param {ApparelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const apparel = /** @type {((inputs?: ApparelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ApparelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_apparel(inputs)
	if (locale === "es") return es_apparel(inputs)
	if (locale === "fr") return fr_apparel(inputs)
	if (locale === "de") return de_apparel(inputs)
	if (locale === "ja") return ja_apparel(inputs)
	if (locale === "zh") return zh_apparel(inputs)
	if (locale === "ar") return ar_apparel(inputs)
	if (locale === "id") return id_apparel(inputs)
	if (locale === "it") return it_apparel(inputs)
	if (locale === "ru") return ru_apparel(inputs)
	if (locale === "pt") return pt_apparel(inputs)
	return ko_apparel(inputs)
});